import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Copy } from '@honda-canada/design-system-react';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import React from 'react';
import Superscript from './shared/Superscript';
import themeStyles from './SpecialOfferCard.styles';
const SellingPriceContainer = themeStyles.apply(Box, 'SellingPriceContainer');
const SellingPriceCopy = themeStyles.apply(Copy, 'SellingPriceCopy');
const PriceWrapper = themeStyles.apply(Box, 'PriceWrapper');
const Price = themeStyles.apply(Copy, 'Price');
const defaultPriceFormatter = (price, language) => formatPrice(price, language);
const text = 'Selling Price From';
const SellingPrice = ({ sellingPrice }) => {
    const { sellingPriceSuperscript } = sellingPrice;
    return (_jsxs(SellingPriceContainer, { children: [_jsx(SellingPriceCopy, { size: "small", children: text }), _jsxs(PriceWrapper, { children: [_jsx(Price, { fontFamily: "bold", children: defaultPriceFormatter(sellingPrice === null || sellingPrice === void 0 ? void 0 : sellingPrice.sellingPrice) }), _jsx(Superscript, { ...sellingPriceSuperscript })] })] }));
};
export default SellingPrice;
